import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import TextField from "@plugins/text-field/text-field";
import TextField2 from "../text-field/text-field-2";
import Dropdown2 from "../dropdown/dropdown-2";
import { createForms, getControlType } from './form.model';
import { snakeCaseToWords } from '../../utility';
import { EventHooks } from '../text-field';

@Component
export default class DynamicForm extends Vue {
  @Prop({ default: () => createForms() }) forms;
  @Prop({ default: () => { } }) formsData;
  @Prop({ default: () => [] }) classNames;
  @Prop({ default: 1 }) version;

  @Prop({
    default: () => {
      return {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur,
      }
    }
  }) textFieldConfig;
  @Prop({
    default: () => {
      return {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
      }
    }
  }) dateFieldConfig;

  onTextFieldValueChange(name, value) {
    this.$emit('changed', { name, value });
  }
  onDatePickerUpdate({ name, value }) {
    this.$emit('changed', { name, value });
  }
  onTextField2ValueChange({ name, value }) {
    console.log('onTextField2ValueChange', name, value);
    this.$emit('changed', { name, value });
  }
  onCheckboxInput(name, event) {
    this.$emit('changed', { name, value: event?.target?.value ? "1" : "0" });
  }
  onCheckbox2Input({ name, value }) {
    this.$emit('changed', { name, value });
  }
  onDropdown2Change(name, value) {
    this.$emit('changed', { name, value: value.value });
  }
  onTextFieldValidated(name, value) {
    this.$emit('validated', { name, value });
  }
  defaultValidationHandler(name, value) {
    this.$emit('validated', { name, value });
  }
  render(createElement) {
    return (
      <div class={['form-group', ...this.classNames].join(' ')}>
        {this.forms.map(form => {
          switch (getControlType(form)) {
            case 'textfield': {
              return (
                this.version === 1 ? <TextField
                  id={form.name}
                  key={form.name}
                  value={this.formsData?.[form.name]}
                  placeholder={snakeCaseToWords(form.name)}
                  required={form.required}
                  onValuechanged={this.onTextFieldValueChange}
                  onValidated={this.onTextFieldValidated}
                  validators={form.validators}
                  {...{ attrs: this.textFieldConfig }}
                  showValidationIcons={form.showValidationIcons}
                /> : <TextField2
                  id={form.name}
                  key={form.name}
                  type={form.type}
                  value={this.formsData?.[form.name]}
                  placeholder={snakeCaseToWords(form.name)}
                  label={snakeCaseToWords(form.name)}
                  required={form.required}
                  onChange={this.onTextField2ValueChange}
                  validators={form.validators}
                  onValidated={this.defaultValidationHandler}
                  showValidationIcons={form.showValidationIcons}
                />
              );
            }
            case 'dropdown': {
              return (
                this.version === 1 ? <Dropdown
                  box={true}
                  class="m1"
                  placeholder={snakeCaseToWords(form.name)}
                  options={form.options}
                  selected={form.options.find(op => op.value == this.formsData?.[form.name])}
                  onSelectedChange={e => this.onDropdown2Change(form.name, e)}
                  onValidated={e => this.defaultValidationHandler(form.name, e)}
                  showValidationIcons={form.showValidationIcons}
                /> : <Dropdown2
                  placeholder={form.text}
                  label={form.text}
                  options={form.options}
                  selected={form.options.find(op => op.value == this.formsData?.[form.name])}
                  onSelectedChange={e => this.onDropdown2Change(form.name, e)}
                  onValidated={e => this.defaultValidationHandler(form.name, e)}
                  showValidationIcons={form.showValidationIcons}
                />
              );
            }
            case 'checkbox': {
              return (
                this.version === 1 ? <DTCheckbox
                  id={form.name}
                  label={form.text}
                  checked={this.formsData?.[form.name] == 1}
                  placeholder={snakeCaseToWords(form.name)}
                  onClick={e => this.onCheckboxInput(form.name, e)}
                /> : <Checkbox2
                  id={form.name}
                  label={form.text}
                  value={this.formsData?.[form.name]}
                  placeholder={snakeCaseToWords(form.name)}
                  onInput={this.onCheckbox2Input}
                />
              );
            }
            case 'date': {
              // <TextField
              //   style="flex: 1"
              //   class="m1"
              //   :type="'date'"
              //   :id="'start_payment'"
              //   v-bind="textFieldConfig"
              //   :value="start_payment"
              //   :placeholder="`${$t('payment')} ${$t('start')}`"
              //   @valuechanged="onTextFieldValueChange"
              // />

              return (
                this.version === 1 ? <TextField
                  type="date"
                  id={form.name}
                  key={form.name}
                  required={form.required}
                  {...{ attrs: this.textFieldConfig }}
                  value={this.formsData?.[form.name]}
                  placeholder={snakeCaseToWords(form.name)}
                  onValuechanged={this.onTextFieldValueChange}
                  onValidated={this.onTextFieldValidated}
                  validators={form.validators}
                  showValidationIcons={form.showValidationIcons}
                /> : <DatePicker2
                id={form.name}
                placeholder={snakeCaseToWords(form.name)}
                label={snakeCaseToWords(form.name)}
                value={this.formsData?.[form.name]}
                onInput={this.onDatePickerUpdate}
                showValidationIcons={form.showValidationIcons}
              />
              // <TextField
              //     type="date"
              //     id={form.name}
              //     key={form.name}
              //     required={form.required}
              //     {...{ attrs: this.textFieldConfig }}
              //     value={this.formsData?.[form.name]}
              //     placeholder={snakeCaseToWords(form.name)}
              //     onValuechanged={this.onTextFieldValueChange}
              //     onValidated={this.onTextFieldValidated}
              //     validators={form.validators}
              //     showValidationIcons={form.showValidationIcons}
              //   />
              );
            }
            default: {
              return (
                <div>Invalid Form Element</div>
              )
            }
          }
        })}
      </div>
    );
  }
}